import { render, staticRenderFns } from "./AffaireTotaux.vue?vue&type=template&id=11d98b75&"
import script from "./AffaireTotaux.vue?vue&type=script&lang=js&"
export * from "./AffaireTotaux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11d98b75')) {
      api.createRecord('11d98b75', component.options)
    } else {
      api.reload('11d98b75', component.options)
    }
    module.hot.accept("./AffaireTotaux.vue?vue&type=template&id=11d98b75&", function () {
      api.rerender('11d98b75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/provisionsRisques/components/AffaireTotaux.vue"
export default component.exports